import { Component, Inject, OnInit } from "@angular/core";
import { MatDialogRef, MAT_DIALOG_DATA } from "@angular/material";
import { SafeResourceUrl } from "@angular/platform-browser";
import { ResizedEvent } from "angular-resize-event";
import { StudyReportEdit } from "../../../model/study-report-edit";
import {
  StudyReportWizardService,
  IStudyReportWizard,
} from "../../../services/wizard/study-report/study-report.wizard.service";
import { NotificationToastService } from "../../../services/notification-toast.service";
import { PdfService } from "../../../services/pdf.service";
import { ReportViewer } from "../../../model/report-viewer";
import {
  StructuredDiagnosisColumn,
  StructuredDiagnosisColumnItem,
} from "src/app/model/study-report-text";
import { AuthService } from "src/app/services/auth.service";
import { ConfirmDialogService } from "src/app/services/confirm-dialog.service";

export class StudyReportViewerDialogRequest {
  public CanConfirm: boolean;
  public CanFix: boolean;
  public CanControl: boolean;
  public PdfBase64: string;
  public studyReportWizard: IStudyReportWizard;
  public StudyReportEdit: StudyReportEdit;
  public SafeResourceUrl: SafeResourceUrl;
  public StructuredDiagnosisColumns: StructuredDiagnosisColumn[] = [];
  public StructuredDiagnosisColumnItems: StructuredDiagnosisColumnItem[] = [];
  public ForceServerReportViewer: boolean;
}

export class StudyReportViewerDialogResponse {
  public ReportViewer: ReportViewer;
  public ControlAdmin: boolean;
  public Fix: boolean;
}

@Component({
  selector: "app-study-report-viewer-dialog",
  templateUrl: "study-report-viewer-dialog.component.html",
  styleUrls: ["./study-report-viewer-dialog.component.css"],
})
export class StudyReportViewerDialogComponent implements OnInit {
  reportViewer: ReportViewer;
  safeResourceUrl: SafeResourceUrl;
  canConfirm: boolean;
  diagnositcRequired: boolean;
  addingDiagnostic: boolean = false;
  addingDiagnosticSelected: boolean = false;
  loading: boolean;
  widthExp = 800;
  heightExp = 800;

  constructor(
    public dialogRef: MatDialogRef<StudyReportViewerDialogComponent>,
    private notificationToastService: NotificationToastService,
    private confirmDialogService: ConfirmDialogService,
    private authService: AuthService,
    private pdfService: PdfService,
    @Inject(MAT_DIALOG_DATA) public data: StudyReportViewerDialogRequest,
  ) {
    this.canConfirm = data.CanConfirm;
    this.diagnositcRequired =
      data.StructuredDiagnosisColumns &&
      data.StructuredDiagnosisColumns.length > 0;
  }

  async ngOnInit() {
    try {
      this.loading = true;

      if (this.data.PdfBase64 && !this.data.ForceServerReportViewer) {
        this.reportViewer = new ReportViewer();
        this.reportViewer.ReportBase64 = this.data.PdfBase64;
        this.setSafeUrl();
      } else if (this.data.StudyReportEdit && this.data.studyReportWizard) {
        if (this.data.ForceServerReportViewer && this.data.PdfBase64) {
          this.data.StudyReportEdit.StudyReportPdf = this.data.PdfBase64;
        }

        this.reportViewer =
          await this.data.studyReportWizard.getStudyReportViewer(
            this.data.StudyReportEdit,
          );
        this.setSafeUrl();
      } else {
        this.safeResourceUrl = this.data.SafeResourceUrl;
      }
    } catch (err) {
      this.notificationToastService.error(JSON.stringify(err.error), "Informe");
    } finally {
      this.loading = false;
    }
  }

  private setSafeUrl() {
    const pdfUrl = this.pdfService.base64ToPdfUrl(
      this.reportViewer.ReportBase64,
    );
    this.safeResourceUrl = this.pdfService.pdfUrlToPdfSafeResourceUrl(pdfUrl);
  }

  getSafeResourceUrl(): SafeResourceUrl {
    return this.safeResourceUrl;
  }

  onNoClick(): void {
    this.dialogRef.close(null);
  }

  confirmClick(): void {
    const physicianId = this.authService.getPhysicianId();

    if (this.data.StudyReportEdit) {
      if (
        this.data.StudyReportEdit.PhysicianSignatureOne !== physicianId &&
        this.data.StudyReportEdit.PhysicianSignatureTwo !== physicianId &&
        this.data.StudyReportEdit.PhysicianSignatureThree !== physicianId &&
        this.data.StudyReportEdit.PhysicianSignatureFour !== physicianId &&
        this.data.StudyReportEdit.PhysicianSignatureFive !== physicianId &&
        this.data.StudyReportEdit.PhysicianSignatureSix !== physicianId
      ) {
        this.confirmDialogService
          .confirm(
            "Confirmación",
            "¿Está seguro de confirmar el informe sin su firma?",
            "Sí",
            "No",
          )
          .subscribe((value) => {
            if (value) {
              this.dialogRef.close({
                ReportViewer: this.reportViewer,
              });
            } else {
              return false;
            }
          });
      } else {
        this.dialogRef.close({
          ReportViewer: this.reportViewer,
        });
      }
    }

    // this.dialogRef.close({
    //   ReportViewer: this.reportViewer,
    // });
  }

  onFixClick(): void {
    this.dialogRef.close({
      Fix: true,
    });
  }

  onConfirmAdminClick(): void {
    this.dialogRef.close({
      ControlAdmin: true,
    });
  }

  addDiagnostic(): void {
    this.addingDiagnostic = true;
    this.addingDiagnosticSelected = true;
  }

  onResized(event: ResizedEvent): void {
    this.widthExp = event.newWidth;
    this.heightExp = event.newHeight;
  }

  hasDiagnosticSelected(): boolean {
    return (
      this.data.StructuredDiagnosisColumnItems &&
      this.data.StructuredDiagnosisColumnItems.findIndex(
        (s) => !s.StepTargetId,
      ) > -1
    );
  }
}
